var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-links-wrapper d-sm-none" }, [
    _c(
      "a",
      { attrs: { href: "tel:+4915221072554" } },
      [_c("icon-component", { attrs: { icon: _vm.fa_phone_alt() } })],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      { attrs: { href: "https://wa.me/+4915221070532" } },
      [
        _c("icon-component", {
          attrs: {
            icon: _vm.fa_whatsapp(),
            height: "1.1em",
            width: "1.1em",
            viewBox: "-50 0 512 512"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "a",
      { attrs: { href: "mailto:info@erobella.com" } },
      [_c("icon-component", { attrs: { icon: _vm.fa_envelope() } })],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "sms:+4915221070532" } }, [
      _c("i", { staticClass: "text-content" }, [_vm._v("SMS")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23f15dc3", { render: render, staticRenderFns: staticRenderFns })
  }
}